"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var react_bootstrap_1 = require("react-bootstrap");

var prop_types_1 = require("prop-types");

var react_router_dom_1 = require("react-router-dom");

var classnames_1 = __importDefault(require("classnames"));

var index_1 = require("../../index");

require("./index.css");

var RelatedAnalysesModal = function (_a) {
  var _b = _a.show,
      show = _b === void 0 ? false : _b,
      onClose = _a.onClose,
      relatedAnalyses = _a.relatedAnalyses,
      projectId = _a.projectId,
      setCloseModal = _a.setCloseModal,
      getViewPathForAnalysis = _a.getViewPathForAnalysis;
  return (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Modal, __assign({
    centered: true,
    show: show,
    onHide: onClose
  }, {
    children: [(0, jsx_runtime_1.jsx)("div", __assign({
      className: "modal-close-container"
    }, {
      children: (0, jsx_runtime_1.jsx)("button", __assign({
        type: "button",
        "data-testid": "related-analyses",
        className: (0, classnames_1.default)('icon-button'),
        onClick: setCloseModal
      }, {
        children: (0, jsx_runtime_1.jsx)(index_1.Icon, {
          name: "close",
          width: 16,
          className: "fill icon-orange-theme"
        }, void 0)
      }), void 0)
    }), void 0), (0, jsx_runtime_1.jsxs)("div", __assign({
      "data-testid": "modal-popover-content",
      className: "modal-popover__content"
    }, {
      children: [(0, jsx_runtime_1.jsx)("div", __assign({
        className: "related-analyses-title"
      }, {
        children: "Related analyses"
      }), void 0), relatedAnalyses.map(function (analysis, index) {
        return (0, jsx_runtime_1.jsx)("div", __assign({
          className: "navigation-connected-content"
        }, {
          children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({
            to: getViewPathForAnalysis(projectId, analysis),
            "data-testid": "navigation-connected-content-" + index,
            className: "connected-analyses__list__link"
          }, {
            children: analysis.title
          }), analysis.contentId)
        }), void 0);
      })]
    }), void 0)]
  }), void 0);
};

RelatedAnalysesModal.propTypes = {
  show: prop_types_1.bool,
  onClose: prop_types_1.func.isRequired,
  projectId: prop_types_1.number.isRequired,
  setCloseModal: prop_types_1.func.isRequired,
  relatedAnalyses: prop_types_1.bool.isRequired,
  getViewPathForAnalysis: prop_types_1.func.isRequired
};
RelatedAnalysesModal.defaultProps = {
  show: false
};
exports.default = RelatedAnalysesModal;